export default "__VITE_ASSET__CsrPwX1B__"